<app-student-summary
  [pupilData]="pupilData"
  [schoolId]="schoolId"
  (goBack)="onNavigateBack($event)"
></app-student-summary>
@if (displayExclusionsList) {
  <app-academic-summary-view
    [pupilData]="pupilData"
    [schoolId]="schoolId"
  ></app-academic-summary-view>
}
@if (displayExclusionsList) {
  <app-student-exclusion-list
    [schoolId]="schoolId"
    [schoolName]="schoolName"
    [studId]="studId"
    [studentName]="pupilData.studentName"
    [isStudentOffRoll]="pupilData.isOffRoll"
    (showExclusionDetails)="showExclusionDetails($event)"
    (refreshAcademicYearSummary)="refreshAcademicYearSummary($event)"
    [createExclusionActionType]="createExclusionActionType"
  ></app-student-exclusion-list>
}
@if (!displayExclusionsList) {
  <app-student-exclusion-details
    [exclusionId]="exclusionId"
    [pupilData]="pupilData"
    [schoolId]="schoolId"
    [accordionActiveState]="accordionActiveState"
    (goBack)="onNavigateBack($event)"
    [isOffRollEditingEnabled]="isOffRollEditingEnabled"
    [createExclusionActionType]="createExclusionActionType"
  ></app-student-exclusion-details>
}
